import { Expose } from 'class-transformer';
import { IsEnum, IsOptional, IsString } from 'class-validator';
import { LockerVendor } from '../../../entities/locker.entity';

export default class UpdateLockerResource {
  @IsString()
  readonly id: string;

  @IsString()
  @Expose({ name: 'locker_id' })
  readonly lockerId: string;

  @IsString()
  @Expose({ name: 'condominium_id' })
  readonly condominium: string;

  @IsEnum(LockerVendor)
  @IsOptional()
  readonly vendor?: LockerVendor;

  constructor(init?: UpdateLockerResource) {
    this.id = init?.id!;
    this.lockerId = init?.lockerId!;
    this.condominium = init?.condominium!;
    this.vendor = init?.vendor;
  }
}
